const baseUrl = process.env.NODE_ENV === 'development' ?
    'http://localhost:5050' : 'https://whereforcare.lghealth.org';

export const emergencyMessage = `${baseUrl}/api/emergencyMessage`;

export const predictiveText = `${baseUrl}/api/predictiveText`;

export const symptomDiagnosis = `${baseUrl}/api/symptomologyDiagnosis`;



// WEBPACK FOOTER //
// ./src/utils/api.ts